// extracted by mini-css-extract-plugin
export default {"uploadTip":"uploadTip___UvDgc"};